/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-self-assign */
/* eslint-disable no-unused-vars */
// import { Add  } from "@mui/icons-material";
import {
  AppBar,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import axios from "axios";
import TimelineItem from "components/Icon/TimelineItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import CustomText from "components/customtext/customtext";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import DisplayModal from "components/displayModel/displayModel";
import Height from "components/height/height";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import DataTable from "examples/Tables/DataTable";
import MuiPhoneNumber from "material-ui-phone-number";
import React, { useEffect, useRef, useState } from "react";
import ReactGoogleAutocomplete from "react-google-autocomplete";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { appConstants } from "utils/appConstants";
import validator from "validator";

let id = undefined;

let LOGIN_DETAILS;
let C_ID;
let orderID;
let orderNumber;
let fetchedOrder;
let fetchOrderStatus;
let setOrderId;
let mandateFlag = false;

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

function EditOrder() {
  //   const { id } = useParams();

  const id = window.location.pathname.split("/").pop();

  const stateListRef = useRef([]);
  const countryListRef = useRef([]);
  const [showReciever, setShowReciever] = useState(false);
  const [screenName, setScreenName] = useState("Add New Order");
  const [loading, setLoading] = useState(false);
  const [hid, setHid] = useState(false);
  const [table, setTable] = useState("orderInformation");
  const [showOrderInformation, setShowOrderInformation] = useState(false);
  const [showOrderItems, setShowOrderItems] = useState(false);
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [readOnly, setReadOnly] = useState(false);
  const [customer, setCustomer] = useState("");
  const [wareHouseName, setwarehouseName] = useState("");

  const [rows, setRows] = useState([]);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [selectedId, setSelectedId] = useState("");

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const [ShipmentType, setShipmentType] = useState(false);
  // const [selectedLocation, setSelectedLocation] = useState("drop at Warehouse");
  const [selectedWarhouse, setSelectedWarhouse] = useState(false);

  const [showWarehouse, setShowWarehouse] = useState(false);

  const [receiverfirstNameErr, setreceiverfirstNameErr] = useState(false);
  const [receiverlastNameErr, setreceiverlastNameErr] = useState(false);
  const [receivermobileNoErr, setreceivermobileNoErr] = useState(false);
  const [pNumberErrMsg, setpNumberErrMsg] = useState("");
  const [receiverstreetAddressErr, setreceiverstreetAddressErr] =
    useState(false);
  const [receivercityErr, setreceivercityErr] = useState(false);
  const [receiverzipCodeErr, setreceiverzipCodeErr] = useState(false);
  const [selectCustomerErr, setSelectCustomerErr] = useState(false);

  const [cargoTypeErr, setcargoTypeErr] = useState(false);
  const [cargoTemperatureErr, setcargoTemperatureErr] = useState(false);
  const [numberOfItemsErr, setnumberOfItemsErr] = useState(false);
  const [lengthErr, setlengthErr] = useState(false);
  const [breadthErr, setbreadthErr] = useState(false);
  const [heightErr, setheightErr] = useState(false);
  const [WeightErr, setWeightErr] = useState(false);

  const [customerTypeErr, setCustomerTypeErr] = useState(false);
  const [businessNameErr, setBussinessNameErr] = useState(false);
  const [bussinessIDErr, setBussinessIDErr] = useState(false);
  const [firstNameErr, setFirstNameErr] = useState(false);
  const [lastNameErr, setLastNameErrErr] = useState(false);
  const [emailAddressErr, setEmailAddressErr] = useState(false);
  const [emailTitleErr, setemailTitleErr] = useState("");
  const [mobileNumberErr, setMobileNumberErr] = useState(false);
  const [streetAddressErr, setStreetAddressErr] = useState(false);
  const [cityErr, setCityErr] = useState(false);
  const [zipCodeErr, setZipCodeErr] = useState(false);
  const [accountNumberErr, setAccountNumberErr] = useState(false);

  const [head, setHead] = useState(true);
  const [defaultDis, setDefaultDis] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);

  function showRecieverDetail() {
    setShowReciever(true);
  }

  const [values, setValues] = React.useState({
    customerID: "",
    phoneNumber: "+61",
    paymentType: "Self-Payment",
    firstName: "",
    lastName: "",
    emailAddress: "",
    streetAddress: "",
    city: "",
    zipCode: "",
    businessID: "",
    businessName: "",
    countryId: "",
    stateId: "",
    customerType: "Individual",
    receiverfirstName: "",
    receiverlastName: "",
    receiverContactNumber: "+61",
    receiverStreetAddress: "",
    receiverCity: "",
    receiverZipCode: "",
    receiverCountryID: "",
    receiverStateID: "",
    shipmentType: "Sender Location Pickup",
    pickupWarehouseID: null,
    accountNumber: "",
    selectUser: "Existing",
    businessUserID: "",
  });

  const [valuesItems, setValuesItems] = React.useState({
    cargoType: "",
    numberOfItems: "",
    cargoTemperature: "",
    lengthInMm: "",
    breadthInMm: "",
    heightInMm: "",
    weightInKg: "",
    description: "",
    orderStatus: "",
    orderID,
  });

  const [valuesOrderID, setValuesOrderID] = React.useState("");
  const [valuesOrderStatus, setOrderStatus] = React.useState("");

  // const handleChange = (name) => (event) => {

  //   setValues({ ...values, [name]: event.target.value });

  // };

  const handleChange = (name) => (event) => {
    if (name === "pickupWarehouseID") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "customerID") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "customerType") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "countryId") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "stateId") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "paymentType") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "receiverCountryID") {
      setValues({ ...values, [name]: event.target.value });
    } else if (name === "receiverStateID") {
      setValues({ ...values, [name]: event.target.value });
    } else if (event.target.validity.valid) {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  const handleChange2 = (name) => (event) => {
    if (name === "cargoTemperature") {
      let value = event.target.value;

      if (
        name === "cargoTemperature" &&
        (valuesItems.cargoType === "Chiller" ||
          valuesItems.cargoType === "Freezer")
      ) {
        value = value.replace(/\D/g, ""); // Remove non-numeric characters

        if (value !== "" && value !== "-") {
          value = -Math.abs(parseFloat(value));
        } else if (value === "-") {
          value = value; // Preserve the "-" character
        } else {
          value = ""; // Clear the value when it is empty
        }
      }

      setValuesItems({ ...valuesItems, [name]: value });
    } else if (name === "cargoType") {
      setValuesItems({ ...valuesItems, [name]: event.target.value });
    } else if (event.target.validity.valid) {
      setValuesItems({ ...valuesItems, [name]: event.target.value });
    }
  };

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  values.businessUserID = LOGIN_DETAILS.businessUserID;

  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Order");
      values.orderID = id;
      setLoading(true);
      axios
        .post(appConstants.baseURL + "order/editOrderforfinalbyId", {
          orderID: values.orderID,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("editOrderforfinalbyId(response)", response);
          if (response.Result_Output !== null) {
            fetchedOrder = response.Result_Output;
            fetchedOrder.selectUser = "Existing";
            fetchOrderStatus = response.Result_Output.orderStatus;

            setValues(fetchedOrder);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in editOrderforfinalbyId=", error);
        });
    }
    if (id !== undefined) {
      valuesItems.orderID = id;
      setLoading(true);
      axios
        .post(appConstants.baseURL + "order/editOrderItemsforfinalbyId", {
          orderID: valuesItems.orderID,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("editOrderItemsforfinalbyId(response)", response);
          if (response.Result_Output.length > 0) {
            setRows(res.data.Result_Output);
            console.log(res.data.Result_Output);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in editOrderItemsforfinalbyId=", error);
        });
    }
  }, []);

  useEffect(() => {
    if (values.selectUser === "New") {
      setHead(false);
      setReadOnly(false);
    } else {
      setHead(true);
    }
  }, [values.selectUser]);

  useEffect(() => {
    if (sessionStorage.getItem("PARA_TABLE") === "orderItems") {
      setTable("orderItems");
    }
    if (table === "orderInformation") {
      setShowOrderInformation(true);
      setShowOrderItems(false);
      setTabValue(0);
    } else if (table === "orderItems") {
      setShowOrderInformation(false);
      setShowOrderItems(true);
      setTabValue(1);
    }
    sessionStorage.removeItem("PARA_TABLE");
  }, [table]);

  useEffect(() => {
    fetchStates();
    fetchCountry();
    fetchBusinessUserByID();
    fetchWarehouseName();
  }, []);

  let fetchStates = async () => {
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "countryState/fetchState", values)
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          values.stateId = response.Result_Output[0]._id;
          values.receiverStateID = response.Result_Output[0]._id;
        }
        setState(response.Result_Output);
        stateListRef.current = response.Result_Output;
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchStates=", error);
      });
  };

  let fetchCountry = async () => {
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "countryState/fetchCountry", values)
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          values.countryId = response.Result_Output[0]._id;
          values.receiverCountryID = response.Result_Output[0]._id;
        }
        setCountry(response.Result_Output);
        countryListRef.current = response.Result_Output;
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchStates=", error);
      });
  };

  const fetchWarehouseName = async () => {
    setLoading(true);
    axios
      .post(appConstants.baseURL + "order/fetchWarehouseByID", values)
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          setwarehouseName(response.Result_Output);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchWarehouseById=", error);
      });
  };

  let fetchBusinessUserByID = async () => {
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "order/fetchCustomerBybusinessID", {
        businessUserID: values.businessUserID,
      })
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          // values.customerID = response.Result_Output[0]._id;
        }
        setCustomer(response.Result_Output);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchStates=", error);
      });
  };

  useEffect(() => {
    if (readOnly === true) {
      if (values.customerID !== undefined && values.customerID !== "") {
        fetchCustomerDetailsById(values.customerID);
        setReadOnly(true);
      }
    }
  }, [values.customerID, readOnly]);

  useEffect(() => {
    if (
      valuesItems.cargoType !== "Chiller" ||
      valuesItems.cargoType !== "Freezer"
    ) {
      setValuesItems((prevValues) => ({
        ...prevValues,
        cargoTemperature: "",
      }));
    }
  }, [valuesItems.cargoType]);

  useEffect(() => {
    if (values.selectUser === "Existing") {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [values.selectUser]);

  useEffect(() => {
    if (values.shipmentType === "drop at Warehouse") {
      setSelectedWarhouse(true);
    } else {
      setSelectedWarhouse(false);
    }
  }, [values.shipmentType]);

  let fetchCustomerDetailsById = async (id) => {
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "order/fetchCustomerDetailsById", {
        customerID: id,
      })
      .then((res) => {
        setLoading(false);
        let response = res.data;
        console.log("response", response);

        if (response.Result_Output.length > 0) {
          const { shipmentType, _id, ...otherValues } =
            response.Result_Output[0];
          setValues((prevValues) => ({ ...prevValues, ...otherValues }));
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchCustomerDetailsById=", error);
      });
  };

  const addOrder = async () => {
    console.log("addOrder(values)", values);

    mandateFlag = false;
    if (values.selectUser === "Existing") {
      if (values.customerID.toString().trim() === "") {
        setSelectCustomerErr(true);
        mandateFlag = true;
      } else setSelectCustomerErr(false);
    } else {
      setSelectCustomerErr(false);
    }
    if (values.customerType === "Business") {
      if (values.businessName.toString().trim() === "") {
        setBussinessNameErr(true);
        mandateFlag = true;
      } else setBussinessNameErr(false);
      if (values.businessID.toString().trim() === "") {
        setBussinessIDErr(true);
        mandateFlag = true;
      } else setBussinessIDErr(false);
    } else {
      setBussinessIDErr(false);
      setBussinessNameErr(false);
    }
    if (values.firstName.toString().trim() === "") {
      setFirstNameErr(true);
      mandateFlag = true;
    } else setFirstNameErr(false);
    if (values.lastName.toString().trim() === "") {
      setLastNameErrErr(true);
      mandateFlag = true;
    } else setLastNameErrErr(false);
    if (values.emailAddress.toString().trim() === "") {
      setEmailAddressErr(true);
      setemailTitleErr("Email Address can't be blank");
      mandateFlag = true;
    } else if (!validator.isEmail(values.emailAddress)) {
      setEmailAddressErr(true);
      setemailTitleErr("Enter valid email address.");
      mandateFlag = true;
    } else setEmailAddressErr(false);
    if (values.phoneNumber.toString().trim() === "") {
      setMobileNumberErr(true);
      setpNumberErrMsg("Mobile Number can't be Blank.");
      mandateFlag = true;
    } else if (values.phoneNumber.toString().length <= 10) {
      setpNumberErrMsg("Mobile Number is invalid.");
      setMobileNumberErr(true);
      mandateFlag = true;
    } else setMobileNumberErr(false);
    if (values.streetAddress.toString().trim() === "") {
      setStreetAddressErr(true);
      mandateFlag = true;
    } else setStreetAddressErr(false);
    if (values.city.toString().trim() === "") {
      setCityErr(true);
      mandateFlag = true;
    } else setCityErr(false);

    if (values.zipCode.toString().trim() === "") {
      setZipCodeErr("ZIP Code can't be blank");
      mandateFlag = true;
    } else if (parseInt(values.zipCode) === 0) {
      setZipCodeErr("ZIP Code can't be Zero");
      mandateFlag = true;
    } else if (values.zipCode.length < 4) {
      setZipCodeErr("ZIP Code should be of 4 digits");
      mandateFlag = true;
    } else setZipCodeErr(false);

    if (values.paymentType === "Account Payment") {
      if (values.accountNumber.toString().trim() === "") {
        setAccountNumberErr(true);
        mandateFlag = true;
      } else {
        setAccountNumberErr(false);
      }
    } else setAccountNumberErr(false);
    if (values.receiverfirstName.toString().trim() === "") {
      setreceiverfirstNameErr(true);
      mandateFlag = true;
    } else setreceiverfirstNameErr(false);
    if (values.receiverfirstName.toString().trim() === "") {
      setreceiverfirstNameErr(true);
      mandateFlag = true;
    } else setreceiverfirstNameErr(false);
    if (values.receiverlastName.toString().trim() === "") {
      setreceiverlastNameErr(true);
      mandateFlag = true;
    } else setreceiverlastNameErr(false);
    if (values.receiverContactNumber.toString().trim() === "") {
      setreceivermobileNoErr(true);
      setpNumberErrMsg("Mobile Number can't be Blank.");
      mandateFlag = true;
    } else if (values.receiverContactNumber.toString().length <= 10) {
      setpNumberErrMsg("Mobile Number is invalid.");
      setreceivermobileNoErr(true);
      mandateFlag = true;
    } else setreceivermobileNoErr(false);
    if (values.receiverStreetAddress.toString().trim() === "") {
      setreceiverstreetAddressErr(true);
      mandateFlag = true;
    } else setreceiverstreetAddressErr(false);
    if (values.receiverCity.toString().trim() === "") {
      setreceivercityErr(true);
      mandateFlag = true;
    } else setreceivercityErr(false);
    if (values.receiverZipCode.toString().trim() === "") {
      setreceiverzipCodeErr(true);
      mandateFlag = true;
    } else setreceiverzipCodeErr(false);
    if (mandateFlag) {
      return;
    }
    setLoading(true);
    console.log("values", values);

    console.log("id", id);
    if (id !== undefined) {
      values._id = id;
      console.log("values(id)", values);

      axios
        .post(appConstants.baseURL + "order/updateOrderDetails", values)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("updateOrderDetails (response)", response);
          setValuesOrderID(response.Result_Output.orderID);
          setOrderStatus(response.Result_Output.orderStatus);
          orderID = response.Result_Output.orderID;
          orderNumber = response.Result_Output.orderNumber;
          if (response.Result_Status) {
            swal({
              title: "Order Information Updated Successfully",
              text: "",
              icon: "success",
              color: "red",
              button: false,
              timer: 1000,
            }).then((value) => {
              //   if (value) {
              //     setShowOrderInformation(false);
              //     setShowOrderItems(true);
              //     setTabValue(1)
              //     setHid(true)
              //   }
              setTimeout(() => {
                window.location.href = "/orders";
              });
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in Add Order=" + JSON.stringify(error));
        });
    }
  };

  const addOrderItems = async () => {
    console.log("valuesItems", valuesItems);

    mandateFlag = false;
    if (valuesItems.cargoType.toString().trim() === "") {
      setcargoTypeErr(true);
      mandateFlag = true;
    } else setcargoTypeErr(false);
    if (
      valuesItems.cargoType === "Chiller" ||
      valuesItems.cargoType === "Freezer"
    ) {
      if (valuesItems.cargoTemperature.toString().trim() === "") {
        setcargoTemperatureErr(true);
        mandateFlag = true;
      } else setcargoTemperatureErr(false);
    } else {
      setcargoTemperatureErr(false);
    }

    if (valuesItems.numberOfItems.toString().trim() === "") {
      setnumberOfItemsErr(true);
      mandateFlag = true;
    } else setnumberOfItemsErr(false);
    if (valuesItems.lengthInMm.toString().trim() === "") {
      setlengthErr(true);
      mandateFlag = true;
    } else setlengthErr(false);
    if (valuesItems.breadthInMm.toString().trim() === "") {
      setbreadthErr(true);
      mandateFlag = true;
    } else setbreadthErr(false);
    if (valuesItems.heightInMm.toString().trim() === "") {
      setheightErr(true);
      mandateFlag = true;
    } else setheightErr(false);
    if (valuesItems.weightInKg.toString().trim() === "") {
      setWeightErr(true);
      mandateFlag = true;
    } else setWeightErr(false);
    if (mandateFlag) {
      return;
    }

    if (valuesItems._id === undefined) {
      console.log("valuesItems._id (undefined)", valuesItems);

      if (id !== undefined) {
        valuesItems.orderID = id;
      } else {
        valuesItems.orderID = valuesOrderID;
      }
      console.log("valuesItems.orderID ", valuesItems.orderID);
      console.log("valuesItems", valuesItems);

      axios
        .post(appConstants.baseURL + "order/addOrderItems", valuesItems)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("addOrderItems(response)", response);

          if (response.Result_Status) {
            swal({
              title: "Order Item Added Successfully!",
              text: "",
              icon: "success",
              color: "red",
              button: false,
              timer: 2000,
            });
            fetchOrderItems();
            setValuesItems({
              cargoType: "",
              numberOfItems: "",
              cargoTemperature: "",
              description: "",
              weightInKg: "",
              lengthInMm: "",
              breadthInMm: "",
              heightInMm: "",
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in addOrderItems=" + JSON.stringify(error));
        });
    } else {
      console.log("else", valuesItems);
      axios
        .post(appConstants.baseURL + "order/updateOrderItems", valuesItems)
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("updateOrderItems(response)", response);

          if (response.Result_Status) {
            swal({
              title: "Order Item updated Successfully!",
              text: "",
              icon: "success",
              color: "red",
              button: false,
              timer: 2000,
            });
            fetchOrderItems();
            setValuesItems({
              cargoType: "",
              numberOfItems: "",
              cargoTemperature: "",
              description: "",
              weightInKg: "",
              lengthInMm: "",
              breadthInMm: "",
              heightInMm: "",
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in addOrderItems=" + JSON.stringify(error));
        });
    }
  };

  const fetchOrderItems = async () => {
    console.log("fetchOrderItems (valuesItems)", valuesItems.orderID);
    setLoading(true);
    await axios
      .post(appConstants.baseURL + "order/fetchOrderItems", {
        orderID: valuesItems.orderID,
      })
      .then((res) => {
        setLoading(false);
        let response = res.data;
        if (response.Result_Output.length > 0) {
          setRows(res.data.Result_Output);
          console.log(res.data.Result_Output);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchOrderItems=" + JSON.stringify(error));
      });
  };

  const handleDisplayDialogeClick = async (_id) => {
    if (rows.length === 0) {
      swal({
        title: "Kindly add atleast One Order Item(s)",
        text: "",
        icon: "error",
        color: "red",
        button: false,
        timer: 3000,
      });
      return;
    } else {
      setSelectedId(_id);
      setDisplayDialogeFlag(!displayDialogeFlag);
    }
  };

  const handleCancel1 = (name) => (event) => {
    setDisplayDialogeFlag(false);
  };

  const handleDisplay = async (id) => {
    getOrderCharges();
    setDisplayDialogeFlag(!displayDialogeFlag);
  };

  const orderStatusUpdate = async () => {
    if (rows.length === 0) {
      swal({
        title: "Kindly add atleast One Order Item(s)",
        text: "",
        icon: "error",
        color: "red",
        button: false,
        timer: 3000,
      });
      return;
    }

    if (id !== "" && id !== undefined) {
      setOrderId = id;
      console.log("setOrderId (id)", setOrderId);
      console.log("fetchOrderStatus (id)", fetchOrderStatus);

      axios
        .post(appConstants.baseURL + "order/orderStatusUpdate", {
          orderID: setOrderId,
          orderStatus: fetchOrderStatus,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            setTimeout(() => {
              window.location.href = "/orders";
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in orderStatusUpdate=" + JSON.stringify(error));
        });
    } else {
      console.log("valuesOrderID(else)", valuesOrderID);
      console.log("valuesOrderStatus(else)", valuesOrderStatus);

      axios
        .post(appConstants.baseURL + "order/orderStatusUpdate", {
          orderID: valuesOrderID,
          orderStatus: valuesOrderStatus,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            setTimeout(() => {
              window.location.href = "/orders";
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in orderStatusUpdate=" + JSON.stringify(error));
        });
    }
  };

  const getOrderCharges = async () => {
    if (rows.length === 0) {
      swal({
        title: "Kindly add atleast One Order Item(s)",
        text: "",
        icon: "error",
        color: "red",
        button: false,
        timer: 3000,
      });
      return;
    }

    if (id !== "" && id !== undefined) {
      setOrderId = id;
      console.log("setOrderId (id)", setOrderId);
      console.log("fetchOrderStatus (id)", fetchOrderStatus);

      axios
        .post(appConstants.baseURL + "order/getOrderCharges", {
          orderID: setOrderId,
          orderStatus: fetchOrderStatus,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("getOrderCharges (response)", response);
          if (response.Result_Status) {
            setTimeout(() => {
              window.location.href = "/orders";
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in orderStatusUpdate=" + JSON.stringify(error));
        });
    } else {
      console.log("valuesOrderID(else)", valuesOrderID);
      console.log("valuesOrderStatus(else)", valuesOrderStatus);
      axios
        .post(appConstants.baseURL + "order/getOrderCharges", {
          orderID: valuesOrderID,
          orderStatus: valuesOrderStatus,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          console.log("getOrderCharges (response)", response);
          if (response.Result_Status) {
            setTimeout(() => {
              window.location.href = "/orders";
            });
          } else {
            swal({
              title: response.Result_Message,
              text: "",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in orderStatusUpdate=" + JSON.stringify(error));
        });
    }
  };

  let stateList =
    state.length > 0 &&
    state.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.stateName}
        </MenuItem>
      );
    }, this);

  let CountryList =
    country.length > 0 &&
    country.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.countryName}
        </MenuItem>
      );
    }, this);

  let CustomerList =
    customer.length > 0 &&
    customer.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.firstName} {item.lastName} ({item.phoneNumber})
        </MenuItem>
      );
    }, this);

  let warehouseNameList =
    wareHouseName.length > 0 &&
    wareHouseName.map((item, i) => {
      return (
        <MenuItem key={i} value={item._id}>
          {item.warehouseName}
        </MenuItem>
      );
    }, this);

  const setPhoneValues = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log(values.onlyPhoneNumber);

    values.phoneNumber = phone.slice(country.dialCode.length);
    if (values.phoneNumber) {
      // add a check for empty string here
      values.phoneNumber = "+" + country.dialCode + values.phoneNumber;
    }

    values.countryCode = "+" + country.dialCode;
  };

  const setPhoneValues1 = (phone, country) => {
    values.onlyPhoneNumber = phone.slice(country.dialCode.length);
    console.log(values.onlyPhoneNumber);

    values.receiverContactNumber = phone.slice(country.dialCode.length);
    if (values.receiverContactNumber) {
      // add a check for empty string here
      values.receiverContactNumber =
        "+" + country.dialCode + values.receiverContactNumber;
    }

    values.countryCode = "+" + country.dialCode;
  };

  const handleCheckboxChange = (event) => {
    setReadOnly(event.target.checked);

    setValues((prevValues) => ({
      ...prevValues,
      customerType: "Individual",
      businessName: "",
      businessID: "",
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "+61",
      streetAddress: "",
      city: "",
      zipCode: "",
      countryId: "",
      stateId: "",
      paymentType: "Self-Payment",
    }));
  };

  const handleEditItemsClick = async (_id) => {
    console.log("edit", _id);
    valuesItems._id = _id;
    console.log("fetchOrderItems (valuesItems)", valuesItems);

    setLoading(true);
    await axios
      .post(appConstants.baseURL + "order/fetchOrderItemsByID", {
        id: valuesItems._id,
      })
      .then((res) => {
        setLoading(false);
        let response = res.data;
        console.log("fetchOrderItemsByID (res)", response);
        if (response.Result_Output) {
          setValuesItems(response.Result_Output);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error in fetchOrderItemsByID=" + JSON.stringify(error));
      });
  };

  const handleDeleteDialogeClick = async (_id) => {
    console.log("dd", _id);
    setSelectedId(_id);
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setDeleteDialogeFlag(false);
  };

  const handleDelete = async (id) => {
    deleteStandardPlanFeature();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteStandardPlanFeature = async () => {
    try {
      sessionStorage.setItem("PARA_TABLE", "orderItems");
      valuesItems._id = selectedId;
      console.log("valuesItems", valuesItems);

      setLoading(true);

      await axios
        .post(appConstants.baseURL + "order/deleteOrderItems", {
          id: valuesItems._id,
        })
        .then((res) => {
          setLoading(false);
          let response = res.data;
          if (response.Result_Status) {
            swal({
              title: "Deleted Successfully!",
              text: " ",
              icon: "success",
              color: "green",
              button: false,
            });
            setTimeout(() => {
              // navigate("/deliveryTime" );
              window.location.href = "/editOrders/" + id;
            }, 1000);
            // setShowOrderInformation(false);
            // setShowOrderItems(true);
            // setTabValue(1);
            // setHid(true);
          } else {
            swal({
              title: response.Result_Message,
              text: " ",
              icon: "error",
              color: "red",
              button: false,
              timer: 2000,
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error in deleteOrderItems API=", error);
        });
    } catch (error) {
      console.log("Catch in deleteStandardPlanFeature API=", error);
    }
  };

  const handleStreetOnChange = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        city: "",
        countryId: "",
        zipCode: "",
        stateId: "",
      }));
    }
  };

  const handleStreetAddress = (place, e) => {
    const countryList = countryListRef.current;
    const stateList = stateListRef.current;
    console.log("place", place);
    const addressComponents = place.address_components || [];
    console.log("addressComponents", addressComponents);
    const latlong = place.geometry.location;

    values.senderLocationLatitude = latlong.lat();
    values.senderLocationLongitude = latlong.lng();
    const data = addressComponents.reduce((acc, item) => {
      if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("postal_code") &&
        item.long_name
      ) {
        acc.zipCode = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("locality") &&
        item.long_name
      ) {
        acc.city = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("route") &&
        item.long_name
      ) {
        acc.streetAddress = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("street_number") &&
        item.long_name
      ) {
        acc.streetNumber = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("country") &&
        item.long_name
      ) {
        acc.countryName = item.long_name; // Store country name temporarily
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("administrative_area_level_1") &&
        item.long_name
      ) {
        acc.stateName = item.long_name; // Store state name temporarily
      }
      return acc;
    }, {});
    const isEmptyAddress = place.name === "";

    // Update specific fields in the values object
    if (!isEmptyAddress) {
      if (data.city) {
        values.city = data.city;
      }
      if (data.streetAddress) {
        if (data.streetNumber !== undefined) {
          values.streetAddress = data.streetNumber + " " + data.streetAddress;
        } else {
          values.streetAddress = data.streetAddress;
        }
      }
      if (data.zipCode) {
        values.zipCode = data.zipCode;
      }

      if (data.countryName && Array.isArray(countryList)) {
        const country = countryList.find(
          (item) => item.countryName === data.countryName
        );
        values.countryId = country ? country._id : "";
      }

      if (data.stateName && Array.isArray(stateList)) {
        const state = stateList.find(
          (item) => item.stateName === data.stateName
        );
        values.stateId = state ? state._id : "";
      }
    } else {
      // Clear the values if place name is empty
      values.city = "";
      values.zipCode = "";
      values.countryId = "";
      values.stateId = "";
    }

    // Create a new object to trigger state update
    setValues((prevValues) => ({
      ...prevValues,
      zipCode: values.zipCode,
      city: values.city,
      countryId: values.countryId,
      stateId: values.stateId,
      streetAddress: values.streetAddress,
      senderLocationLongitude: values.senderLocationLongitude,
      senderLocationLatitude: values.senderLocationLatitude,
    }));
  };

  const handleStreetOnChange1 = (e) => {
    if (e.target.value === "") {
      setValues((prevValues) => ({
        ...prevValues,
        receiverCity: "",
        receiverZipCode: "",
        receiverCountryID: "",
        receiverStateID: "",
      }));
    }
  };

  const handleStreetAddress1 = (place, e) => {
    const countryList = countryListRef.current;
    const stateList = stateListRef.current;
    console.log("place", place);
    const addressComponents = place.address_components || [];
    console.log("addressComponents", addressComponents);
    const latlong = place.geometry.location;
    values.receiverLocationLatitude = latlong.lat();
    values.receiverLocationLongitude = latlong.lng();
    const data = addressComponents.reduce((acc, item) => {
      if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("postal_code") &&
        item.long_name
      ) {
        acc.zipCode = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("locality") &&
        item.long_name
      ) {
        acc.city = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("route") &&
        item.long_name
      ) {
        acc.streetAddress = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("street_number") &&
        item.long_name
      ) {
        acc.streetNumber = item.long_name;
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("country") &&
        item.long_name
      ) {
        acc.countryName = item.long_name; // Store country name temporarily
      } else if (
        item.types &&
        Array.isArray(item.types) &&
        item.types.includes("administrative_area_level_1") &&
        item.long_name
      ) {
        acc.stateName = item.long_name; // Store state name temporarily
      }
      return acc;
    }, {});
    const isEmptyAddress = place.name === "";

    // Update specific fields in the values object
    if (!isEmptyAddress) {
      if (data.city) {
        values.receiverCity = data.city;
      }
      if (data.streetAddress) {
        if (data.streetNumber !== undefined) {
          values.streetAddress = data.streetNumber + " " + data.streetAddress;
        } else {
          values.streetAddress = data.streetAddress;
        }
      }
      if (data.zipCode) {
        values.receiverZipCode = data.zipCode;
      }

      if (data.countryName && Array.isArray(countryList)) {
        const country = countryList.find(
          (item) => item.countryName === data.countryName
        );
        values.receiverCountryID = country ? country._id : "";
      }

      if (data.stateName && Array.isArray(stateList)) {
        const state = stateList.find(
          (item) => item.stateName === data.stateName
        );
        values.receiverStateID = state ? state._id : "";
      }
    } else {
      // Clear the values if place name is empty
      values.receiverCity = "";
      values.receiverZipCode = "";
      values.receiverCountryID = "";
      values.receiverStateID = "";
    }

    // Create a new object to trigger state update
    setValues((prevValues) => ({
      ...prevValues,
      receiverZipCode: values.receiverZipCode,
      receiverCity: values.receiverCity,
      receiverCountryID: values.receiverCountryID,
      receiverStateID: values.receiverStateID,
      receiverStreetAddress: values.receiverStreetAddress,
      receiverLocationLongitude: values.receiverLocationLongitude,
      receiverLocationLatitude: values.receiverLocationLatitude,
    }));
  };

  const orderInformation = (
    <>
      {showOrderInformation && (
        <MDBox mt={6} mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={6}>
              <MDBox px={2} py={2}>
                <Grid container columnSpacing={5}>
                  <Grid item xs={1.4}>
                    {" "}
                    <FormLabel
                      id="demo-row-radio-buttons-group-label"
                      sx={{ fontSize: "15px" }}
                    >
                      Customer Type:
                    </FormLabel>
                  </Grid>
                  <Grid item xs={2.8}>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        defaultValue="Existing"
                        onChange={handleChange("selectUser")}
                        value={values.selectUser}
                      >
                        <FormControlLabel
                          value="Existing"
                          control={<Radio />}
                          label="Existing"
                        />
                        <FormControlLabel
                          value="New"
                          control={<Radio />}
                          label="New"
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {/* <Grid item lg={4} xs={12} sx={{ display: "flex", alignItems: "end" }}>
                <FormControl fullWidth>
                  <InputLabel id="userStatus">Customer Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="Customer Type"
                    onChange={handleChange("selectUser")}
                      value={values.selectUser}
                  >
                     <MenuItem value="Existing">Existing</MenuItem>
                    <MenuItem value="New">New</MenuItem>
                    
                    
                  </Select>
                </FormControl>
              </Grid> */}

                  <>
                    {/* <Grid item lg={2} xs={12} sx={{ display: "flex", alignItems: "end" }}>
                <FormControl fullWidth>
                  <InputLabel id="userStatus">Select User</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    style={{ minHeight: "3em" }}
                    label="Select User"
                    
                  >
                 <MenuItem value="Existing">Select</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}

                    <Grid item xs={1.5} pl={0}>
                      {" "}
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        sx={{ fontSize: "16px" }}
                      >
                        Shipment Type:
                      </FormLabel>
                    </Grid>
                    <Grid item xs={3.5}>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          defaultValue={values.shipmentType}
                          value={values.shipmentType}
                          onChange={handleChange("shipmentType")}
                          disabled={hid ? true : false}
                        >
                          <FormControlLabel
                            value="Sender Location Pickup"
                            control={<Radio />}
                            label="Location Pickup"
                          />
                          <FormControlLabel
                            value="drop at Warehouse"
                            control={<Radio />}
                            label="Drop at Warehouse"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </>

                  {selectedWarhouse && (
                    <Grid item lg={2.8} xs={12}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select">
                          Select Warehouse
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          label="Select Warehouse"
                          disabled={hid ? true : false}
                          value={values.pickupWarehouseID}
                          onChange={handleChange("pickupWarehouseID")}
                        >
                          {warehouseNameList}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                </Grid>
              </MDBox>

              <>
                <MDBox px={2} py={1}>
                  {head && (
                    <Grid container columnSpacing={5}>
                      <Grid item xs={12} lg={4}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select">
                            Select Customer
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Select Customer"
                            value={values.customerID}
                            onChange={handleChange("customerID")}
                            // disabled={readOnly }
                          >
                            {CustomerList}
                          </Select>
                          {selectCustomerErr ? (
                            <span style={errMsg}>
                              Select Customer can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} lg={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={readOnly}
                                onChange={handleCheckboxChange}
                              />
                            }
                            label="Sender Address Same"
                            disabled={hid ? true : false}
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  )}
                </MDBox>
                <MDBox px={2} pt={1}>
                  <CustomText type="b" size={17} style={{ fontWeight: 500 }}>
                    Sender Address
                  </CustomText>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={4}>
                      <FormControl fullWidth>
                        <InputLabel id="userStatus">Customer Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          label="Customer Type"
                          value={values.customerType}
                          onChange={handleChange("customerType")}
                          disabled={readOnly}
                        >
                          <MenuItem value="Individual">Individual</MenuItem>
                          <MenuItem value="Business">Business</MenuItem>
                        </Select>
                        {customerTypeErr ? (
                          <span style={errMsg}>
                            Customer Type can't be blank
                          </span>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Business Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.businessName}
                            onChange={handleChange("businessName")}
                            disabled={
                              values.customerType === "Individual"
                                ? true
                                : false || readOnly
                            }
                          />
                          {businessNameErr ? (
                            <span style={errMsg}>
                              Business Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="ABN"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.businessID}
                            onChange={handleChange("businessID")}
                            disabled={
                              values.customerType === "Individual"
                                ? true
                                : false || readOnly
                            }
                          />
                          {bussinessIDErr ? (
                            <span style={errMsg}>ABN can't be blank</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>

                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.firstName}
                            onChange={handleChange("firstName")}
                            disabled={readOnly}
                          />
                          {firstNameErr ? (
                            <span style={errMsg}>
                              First Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.lastName}
                            onChange={handleChange("lastName")}
                            disabled={readOnly}
                          />
                          {lastNameErr ? (
                            <span style={errMsg}>Last Name can't be blank</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Email Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              // pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 50,
                            }}
                            value={values.emailAddress}
                            onChange={handleChange("emailAddress")}
                            disabled={readOnly}
                          />
                          {emailAddressErr ? (
                            <span style={errMsg}>{emailTitleErr}</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <MuiPhoneNumber
                            defaultCountry={"australia"}
                            type="text"
                            label="Mobile Number"
                            variant="outlined"
                            fullWidth
                            value={values.phoneNumber}
                            onChange={(phone, country) =>
                              setPhoneValues(phone, country)
                            }
                            disabled={readOnly}
                          />
                          {mobileNumberErr ? (
                            <span style={errMsg}>{pNumberErrMsg}</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          {/* <TextField
                            type="text"
                            label="Street Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9, ]+$",
                              maxLength: 100
                            }}
                            value={values.streetAddress}
                            onChange={handleChange("streetAddress")}
                            disabled={readOnly}

                          /> */}
                          <ReactGoogleAutocomplete
                            className="GoogleInput"
                            placeholder="Street Address"
                            apiKey={appConstants.googleAutoCommpleteKey}
                            onChange={handleStreetOnChange}
                            onPlaceSelected={(place, e) =>
                              handleStreetAddress(place, e)
                            }
                            disabled={readOnly}
                            options={{
                              types: ["address"],
                              componentRestrictions: { country: "au" },
                            }}
                            inputClassName="GoogleInput" // Add a class name to the input element
                            // value={values.streetAddress}
                            defaultValue={values.streetAddress}
                          />
                          {streetAddressErr ? (
                            <span style={errMsg}>
                              Street Address can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.city}
                            onChange={(e) =>
                              setValues({ ...values, city: e.target.value })
                            }
                            // onChange={handleChange("city")}
                            disabled={readOnly}
                          />
                          {cityErr ? (
                            <span style={errMsg}>City can't be blank</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 4,
                            }}
                            value={values.zipCode}
                            onChange={(e) =>
                              setValues({ ...values, zipCode: e.target.value })
                            }
                            // onChange={handleChange("zipCode")}
                            disabled={readOnly}
                          />
                          {zipCodeErr !== "" ? (
                            <span style={errMsg}>{zipCodeErr}</span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Country
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Country"
                            value={values.countryId}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                countryId: e.target.value,
                              })
                            }
                            // onChange={handleChange("countryId")}
                            disabled={readOnly}
                          >
                            {CountryList}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            State
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="State"
                            value={values.stateId}
                            onChange={(e) =>
                              setValues({ ...values, stateId: e.target.value })
                            }
                            // onChange={handleChange("stateId")}
                            disabled={readOnly}
                          >
                            {stateList}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Payment Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Payment Type"
                            onChange={handleChange("paymentType")}
                            value={values.paymentType}
                            disabled={readOnly}
                          >
                            <MenuItem value="Self-Payment">
                              Self-Payment
                            </MenuItem>
                            <MenuItem value="Account Payment">
                              Account Payment
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Account Number"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[A-Z0-9]+$",
                              maxLength: 30,
                            }}
                            value={values.accountNumber}
                            onChange={handleChange("accountNumber")}
                            disabled={
                              values.paymentType === "Self-Payment"
                                ? true
                                : false || readOnly
                            }
                          />
                          {accountNumberErr ? (
                            <span style={errMsg}>
                              Account Number can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox px={2}>
                  <CustomText type="b" size={17} style={{ fontWeight: 500 }}>
                    Receiver Address
                  </CustomText>

                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="First Name"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                            value={values.receiverfirstName}
                            onChange={handleChange("receiverfirstName")}
                            disabled={hid ? true : false}
                          />
                          {receiverfirstNameErr ? (
                            <span style={errMsg}>
                              Receiver First Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Last Name"
                            variant="outlined"
                            fullWidth
                            value={values.receiverlastName}
                            onChange={handleChange("receiverlastName")}
                            disabled={hid ? true : false}
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 30,
                            }}
                          />
                          {receiverlastNameErr ? (
                            <span style={errMsg}>
                              Receiver Last Name can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MuiPhoneNumber
                        defaultCountry={"australia"}
                        type="text"
                        label="Mobile Number"
                        variant="outlined"
                        fullWidth
                        value={values.receiverContactNumber}
                        onChange={(phone, country) =>
                          setPhoneValues1(phone, country)
                        }
                        disabled={hid ? true : false}
                      />
                      {receivermobileNoErr ? (
                        <span style={errMsg}>{pNumberErrMsg}</span>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          {/* <TextField
                            type="text"
                            label="Street Address"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9, ]+$",
                              maxLength: 100
                            }}
                            value={values.receiverStreetAddress}
                            onChange={handleChange("receiverStreetAddress")}
                            disabled={hid ? true : false}
                          /> */}
                          <ReactGoogleAutocomplete
                            className="GoogleInput"
                            placeholder="Street Address"
                            apiKey={appConstants.googleAutoCommpleteKey}
                            onChange={handleStreetOnChange1}
                            onPlaceSelected={(place, e) =>
                              handleStreetAddress1(place, e)
                            }
                            disabled={hid ? true : false}
                            options={{
                              types: ["address"],
                              componentRestrictions: { country: "au" },
                            }}
                            inputClassName="GoogleInput" // Add a class name to the input element
                            defaultValue={values.receiverStreetAddress}
                          />
                          {receiverstreetAddressErr ? (
                            <span style={errMsg}>
                              Receiver Street Address can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="City"
                            variant="outlined"
                            fullWidth
                            value={values.receiverCity}
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 50,
                            }}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                receiverCity: e.target.value,
                              })
                            }
                            // onChange={handleChange("receiverCity")}
                            disabled={hid ? true : false}
                          />
                          {receivercityErr ? (
                            <span style={errMsg}>
                              Receiver City can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4} xs={12}>
                          <TextField
                            type="text"
                            label="Zip Code"
                            variant="outlined"
                            fullWidth
                            value={values.receiverZipCode}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                receiverZipCode: e.target.value,
                              })
                            }
                            // onChange={handleChange("receiverZipCode")}
                            disabled={hid ? true : false}
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 4,
                            }}
                          />
                          {receiverzipCodeErr ? (
                            <span style={errMsg}>
                              Receiver Zip Code can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Country
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Country"
                            value={values.receiverCountryID}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                receiverCountryID: e.target.value,
                              })
                            }
                            // onChange={handleChange("receiverCountryID")}
                            disabled={hid ? true : false}
                          >
                            {CountryList}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            State
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="State"
                            value={values.receiverStateID}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                receiverStateID: e.target.value,
                              })
                            }
                            // onChange={handleChange("receiverStateID")}
                            disabled={hid ? true : false}
                          >
                            {stateList}
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </>
            </Grid>
          </Grid>
          <Grid
            container
            mt={2}
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <Link to={`/orders`}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            {!hid && (
              <>
                <Grid item xs={12} md={4} lg={1.2}>
                  <MDButton
                    rel="noreferrer"
                    variant="gradient"
                    color="success"
                    fullWidth
                    onClick={addOrder}
                  >
                    {id === undefined ? "Save" : "Update"}
                  </MDButton>
                </Grid>
              </>
            )}
            <Grid item xs={12} md={4} lg={1.2}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                // onClick={orderStatusUpdate}
                onClick={handleDisplayDialogeClick}
              >
                Finalize
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      )}
    </>
  );

  const orderItems = (
    <>
      {showOrderItems && (
        <>
          <MDBox mt={6} mb={3}>
            <Grid container spacing={2}>
              <Grid item xs={12} spacing={6}>
                <MDBox px={2} pt={2}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={2}>
                      <FormControl fullWidth>
                        <InputLabel id="userStatus">Cargo Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          style={{ minHeight: "3em" }}
                          label="Cargo Type"
                          value={valuesItems.cargoType}
                          onChange={handleChange2("cargoType")}
                        >
                          <MenuItem value="Chiller">Chiller </MenuItem>
                          <MenuItem value="Dangerous">Dangerous </MenuItem>
                          <MenuItem value="Bulk">Bulk </MenuItem>
                          <MenuItem value="Freezer">Freezer</MenuItem>
                          <MenuItem value="Goods">Goods</MenuItem>
                        </Select>
                        {cargoTypeErr ? (
                          <span style={errMsg}>Cargo Type can't be blank</span>
                        ) : (
                          ""
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="numeric"
                            label="Cargo Temperature"
                            variant="outlined"
                            fullWidth
                            disabled={
                              valuesItems.cargoType === "Chiller" ||
                              valuesItems.cargoType === "Freezer"
                                ? false
                                : true
                            }
                            inputProps={{
                              pattern: "^-?[0-9]*\\.?[0-9]+$", // Allow negative numbers
                            }}
                            value={valuesItems.cargoTemperature}
                            onChange={handleChange2("cargoTemperature")}
                          />

                          {cargoTemperatureErr ? (
                            <span style={errMsg}>
                              Cargo Temperature can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Number of Items"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9]+$",
                              maxLength: 5,
                            }}
                            value={valuesItems.numberOfItems}
                            onChange={handleChange2("numberOfItems")}
                          />
                          {numberOfItemsErr ? (
                            <span style={errMsg}>
                              Number of items can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Item Length (mm)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9.]+$",
                              maxLength: 5,
                            }}
                            value={valuesItems.lengthInMm}
                            onChange={handleChange2("lengthInMm")}
                          />
                          {lengthErr ? (
                            <span style={errMsg}>
                              Item length can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Item Width (mm)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9.]+$",
                              maxLength: 5,
                            }}
                            value={valuesItems.breadthInMm}
                            onChange={handleChange2("breadthInMm")}
                          />
                          {breadthErr ? (
                            <span style={errMsg}>
                              Item Width can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Item Height (mm)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9.]+$",
                              maxLength: 5,
                            }}
                            value={valuesItems.heightInMm}
                            onChange={handleChange2("heightInMm")}
                          />
                          {heightErr ? (
                            <span style={errMsg}>
                              Item Height can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={4}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Item Weight (Kg.)"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[0-9.]+$",
                              maxLength: 5,
                            }}
                            value={valuesItems.weightInKg}
                            onChange={handleChange2("weightInKg")}
                          />
                          {WeightErr ? (
                            <span style={errMsg}>
                              Item Weight can't be blank
                            </span>
                          ) : (
                            ""
                          )}
                        </MDBox>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                      <MDBox component="form" role="form">
                        <MDBox mb={4}>
                          <TextField
                            type="text"
                            label="Item Description"
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              pattern: "^[a-zA-Z0-9 ]+$",
                              maxLength: 500,
                            }}
                            value={valuesItems.description}
                            onChange={handleChange2("description")}
                          />
                        </MDBox>
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox px={2}>
                  {/* <CustomText type="b" size={17} style={{ fontWeight: 500 }}>
                     Item Measurements (mm)
                    </CustomText> */}
                  <Grid container columnSpacing={5}></Grid>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <Grid
            container
            columnSpacing={4}
            alignItems="center"
            display="flex"
            justifyContent="center"
          >
            <Grid item xs={12} md={4} spacing={2} lg={1.2}>
              <Link to={`/orders`}>
                <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                  Cancel
                </MDButton>
              </Link>
            </Grid>
            <Grid item xs={12} md={4} lg={1.2}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                onClick={addOrderItems}
              >
                {valuesItems._id === undefined ? "Save" : "Update"}
              </MDButton>
            </Grid>

            <Grid item xs={12} md={4} lg={1.2}>
              <MDButton
                rel="noreferrer"
                variant="gradient"
                color="success"
                fullWidth
                // onClick={orderStatusUpdate}
                onClick={handleDisplayDialogeClick}
              >
                Finalize
              </MDButton>
            </Grid>
          </Grid>
          <DataTable
            style={{ marginTop: "0px" }}
            // loading={loading}
            // onReload={() => reloadData()}
            Header={false}
            screenName="Employees"
            addNew={false}
            link="/addEmployee"
            canSearch={false}
            table={{
              // filterable: true,
              // filterMethod,
              rows,
              columns: [
                {
                  Header: "Cargo Type",
                  accessor: "cargoType",
                  align: "center",
                },

                {
                  Header: "Temperature (c)",
                  accessor: "cargoTemperature",
                  align: "center",
                },

                {
                  Header: "Number of Items",
                  accessor: "numberOfItems",
                  align: "center",
                },
                {
                  Header: "Dimension (mm3)",
                  accessor: (row) =>
                    row.lengthInMm +
                    "*" +
                    row.breadthInMm +
                    "*" +
                    row.heightInMm,
                  align: "center",
                },

                {
                  Header: "Weight (kg.)",
                  accessor: "weightInKg",
                  align: "center",
                },

                {
                  Header: "Item Description",
                  accessor: "description",
                  align: "center",
                  width: "25%",
                },

                {
                  Header: "actions",
                  align: "center",
                  accessor: "_id",
                  Cell: ({ value }) => (
                    <>
                      {/* <Link
                          to={{
                            pathname: SCREEN_RIGHT === "Full Access" ? "/standardFeatures/edit/" + value : "/standardFeatures",
                            state: { row: rows.find((row) => row.id === value) },
                          }}
                        > */}
                      <Grid container spacing={5} mt={-6.2}>
                        <Grid item style={{ marginLeft: "-20px" }}>
                          {/* <Link to={`/editEmployee/${value}`}> */}
                          <TimelineItem
                            color="success"
                            icon="edit"
                            title="Edit"
                            onClick={() => handleEditItemsClick(value)}
                          />
                          {/* </Link> */}
                        </Grid>
                        <Grid item>
                          <TimelineItem
                            color="error"
                            icon="delete"
                            onClick={() => handleDeleteDialogeClick(value)}
                            title="Delete Items"
                          />
                        </Grid>
                      </Grid>
                    </>
                  ),
                },
              ],
            }}
            // rows={values.roles}

            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={true}
            pagination={{ variant: "gradient" }}
            noEndBorder
          />{" "}
        </>
      )}
    </>
  );

  const renderTable = () => {
    return (
      <>
        {orderInformation}
        {orderItems}
      </>
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container>
          <Grid item xs={12} md={6} lg={6} px={2} mb={-3.5}>
            <AppBar position="inherit">
              <Tabs
                orientation={tabsOrientation}
                value={tabValue}
                onChange={handleSetTabValue}
                indicatorColor={"primary"}
                sx={{
                  "& .Mui-selected": { color: "#fff !important" },
                }}
              >
                <Tab
                  onClick={() => setTable("orderInformation")}
                  label="Order Information"
                />
                <Tab
                  onClick={() => setTable("orderItems")}
                  label="Order Items"
                />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        {renderTable()}
      </Card>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />

      <DisplayModal
        open={displayDialogeFlag}
        handleDelete={handleDisplay}
        handleCancel={handleCancel1("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default EditOrder;
